import React from 'react';
import { Row, Col } from "react-bootstrap";
import PropTypes from 'prop-types';
import { FormControl, FormControlLabel, FormHelperText, Switch, Tooltip } from '@mui/material';
import { Info as InfoIcon } from '@mui/icons-material';
import { useController, useFormContext, useForm } from "react-hook-form";
import { ConvertBooleanToString } from '../Formatters/ConvertBoolean';

export default function SwitchInput(props) {
  const { name, label, helpText, switchColumnSize, onChange, onBlur, ...switchProps } = props;

  const formContext = useFormContext();
  const fallbackForm = useForm();
  const { control } = formContext ?? fallbackForm; // fallback if not inside FormProvider

  const {
    field,
    fieldState: { error }
  } = useController({ name, control });

  const handleChange = (option) => {
    field.onChange(ConvertBooleanToString(option.target.checked))
    onChange && onChange(option)
  }

  const handleBlur = (event) => {
    field.onBlur();
    onBlur && onBlur(event);
  };

  const columnSize = switchColumnSize || 12;

  return (
    <Row>
      <Col xs={columnSize}>
        <FormControl component="fieldset" error={!!error}>
          <FormControlLabel
            control={
              <Switch
                {...switchProps}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            }
            label={label}
          />
          <FormHelperText>{error?.message}</FormHelperText>
        </FormControl>
      </Col>

      {helpText &&
        <Col xs={2}>
          <div className="d-flex mt-2">
            <Tooltip title={helpText} enterTouchDelay={0}>
              <InfoIcon color="action"></InfoIcon>
            </Tooltip>
          </div>
        </Col>
      }
    </Row>
  )
}

SwitchInput.propTypes = {
  id: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  helpText: PropTypes.string,
  onBlur: PropTypes.func,
  switchColumnSize: PropTypes.number,
};
